<script setup>
// A table sized for reading across a room: few columns, big type, the name
// column taking the slack. Columns: {key, label, num?, width?, strong?}.
// The first `lead` rows (e.g. the top of a league) get the accent edge; pass 0
// while nothing has been played, when everybody is level.
defineProps({
  columns: {type: Array, required: true},
  rows: {type: Array, required: true},
  rowKey: {type: Function, default: (row, i) => i},
  lead: {type: Number, default: 0},
  dense: {type: Boolean, default: false},
});
</script>

<template>
  <table class="tv-table" :class="{'tv-table--dense': dense}">
    <thead>
      <tr>
        <th v-for="col in columns" :key="col.key" :class="{'tv-num': col.num}" :style="col.width ? {width: col.width} : null">
          {{ col.label }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, i) in rows" :key="rowKey(row, i)" :class="{'tv-lead': i < lead}">
        <td v-for="col in columns" :key="col.key" :class="{'tv-num': col.num, 'tv-strong': col.strong, 'tv-pos': col.key === 'position'}">
          <slot :name="col.key" :row="row">{{ row[col.key] }}</slot>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped lang="scss">
.tv-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

th {
  text-align: left;
  font-size: 20px;
  font-weight: 500;
  color: var(--tv-muted);
  padding: 0 20px 10px;
  border-bottom: 2px solid var(--tv-line);
}

td {
  height: 54px;
  padding: 0 16px;
  font-size: 22px;
  letter-spacing: -0.3px;
  color: var(--tv-ink);
  border-bottom: 1px solid var(--tv-line);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tv-table--dense td {
  height: 58px;
  font-size: 30px;
}

.tv-num {
  text-align: right;
  font-family: var(--tv-display);
  font-variant-numeric: tabular-nums;
  font-size: 28px;
  letter-spacing: 0;
}

th.tv-num {
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
}

.tv-strong {
  font-weight: 700;
}

.tv-pos {
  font-family: var(--tv-display);
  font-weight: 700;
  font-size: 28px;
  letter-spacing: 0;
  color: var(--tv-muted);
  text-align: left;
}

.tv-lead td {
  background: var(--tv-lead);
}

.tv-lead td:first-child {
  box-shadow: inset 8px 0 0 var(--tv-accent);
}

.tv-lead .tv-pos {
  color: var(--tv-accent-text);
}
</style>
